<script>
import {Bar} from 'vue-chartjs'


export default Bar.extend({
  name: 'portfolio-bar-chart',
  /**
   *
   * @returns {{options: {responsive: boolean, responsiveAnimationDuration: number, legend: {display: boolean}, scales: {xAxes: [*], yAxes: [*]}}}}
   */
  data() {
    return {
      options: {
        responsive: false,
        responsiveAnimationDuration: 0,
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            // fontFamily: '"Inter", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
            fontSize: 40,
            boxWidth: 100,
            padding: 40,
          }
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 60,
            bottom: 20
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: true,
              drawBorder: false,
              lineWidth: 4,
              offsetGridLines: false,
              zeroLineWidth: 0
            },
            ticks: {
              fontColor: "black",
              drawBorder: false,
              padding: 40,
              fontSize: 35,
              offset: true,
              // fontFamily: '"Inter", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
              // callback(value, index, values) {
              //   return value + ' %'
              // }
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              drawBorder: false,
              lineWidth: 4,
              zeroLineWidth: 0
            },
            ticks: {
              padding: 40,
              suggestedMax: Math.max(...this.chartData.datasets.map(el => {
                return Math.max(...el.data)
              })) + 5,
              fontColor: "black",
              // fontFamily: '"Inter", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
              fontSize: 35,
              callback(value, index, values) {
                return value + ' %'
              }
            }
          }]
        },
        animation: {
          duration: 0,
          onComplete: function () {
            let chartInstance = this.chart
            let ctx = chartInstance.ctx
            let datasets = this.data.datasets

            ctx.font = Chart.helpers.fontString(35, 35, Chart.defaults.global.defaultFontFamily)
            ctx.textAlign = 'center'
            ctx.textBaseline = 'bottom'

            //
            // const maxValue = Math.max(...datasets.map(el => {
            //   return Math.max(...el.data)
            // }))
            // const minValue = Math.min(...datasets.map(el => {
            //   return Math.min(...el.data)
            // }))
            //
            // const ticks = chartInstance.scales['y-axis-0'].ticksAsNumbers
            // const yRange = Math.max(...ticks) - Math.min(...ticks)
            //
            // let yScale = chartInstance.scales["y-axis-0"]
            // let yZero = yScale.getPixelForValue(0)

            datasets.forEach(function (dataset, i) {
              const meta = chartInstance.controller.getDatasetMeta(i)
              meta.data.forEach(function (bar, index) {
                const data = dataset.data[index]
                let labelConfig = null
                // const currentAxisRatio = Math.abs(data > 0 ? maxValue : minValue) / yRange
                // const currentDataToAxisRatio = Math.abs(data) / yRange
                // if (
                //   (currentAxisRatio <= .2)
                //   || (currentAxisRatio <= .3 && currentDataToAxisRatio < .19)
                // ) {
                //   labelConfig = {
                //     color: '#333',
                //     y: yZero - (data > 0 ? -55 : 5)
                //   }
                // } else if (currentDataToAxisRatio >= .19) {
                //   labelConfig = {
                //     color: '#fff',
                //     verticalOffset: data > 0 ? 55 : -5
                //   }
                // } else {
                  labelConfig = {
                    color: '#000',
                    verticalOffset: data < 0 ? 55 : -5
                  }
                // }


                ctx.fillStyle = labelConfig.color
                ctx.fillText(
                  data.toFixed(2).replace('.', ',') + ' %',
                  bar._model.x,
                  labelConfig.y ? labelConfig.y : bar._model.y + labelConfig.verticalOffset
                )
              })
            })
          }
        }
      }
    }
  },

  props: ['chartData', 'settings'],

  mounted() {
    this.renderChart(this.chartData, this.options)
    setTimeout(() => {
      this.$emit('generateChartImage', this._chart.toBase64Image())
    }, 2000)
  }
})
</script>



// WEBPACK FOOTER //
// ChartPortfolioBar.vue?0a05eb44